import { Price } from '@app/shared/models/price.model';

export enum PcmProductCategoryType {
  Unknown = 'Unknown',
  MobilePlan = 'MobilePlan',
  Addon = 'Addon',
  DeliveryOption = 'DeliveryOption',
  CustomerService = 'CustomerService',
  Binding = 'Binding',
  IncludedAddon = 'IncludedAddon',
  Discount = 'Discount',
  DataFrihet = 'DataFrihet',
  MobileService = 'MobileService',
  BarringService = 'BarringService',
  AdditionalService = 'AdditionalService',
  DataPackage = 'DataPackage',
  PayAsYouGo = 'PayAsYouGo',
  TopUp = 'TopUp',
  TopUpRoW = 'TopUpRoW',
  RoamingPackage = 'RoamingPackage',
  ValueAddedService = 'ValueAddedService',
}

export class PcmProductCategory {
  description: string;
  value: PcmProductCategoryType;
}

export class PcmProductPrice {
  price: Price;
  discountPeriod: number;
  isCustomerDiscount: boolean;
  isDiscounted: boolean;
  originalPrice: Price;
}

export class PcmProduct {
  pcmProductId: string;
  productName: string;
  productCategory: PcmProductCategory;
  labels: string[];
  monthlyPrice: PcmProductPrice;
  oneTimePrice: PcmProductPrice;
}

enum PcmBindingType {
  Sim,
  Handset,
}

enum PcmCommitmentType {
  Unknown = 0,
  None,
  Avtalebinding,
  SimAvtaleBinding,
  Terminalbinding,
  Utkjopsbinding,
  Tjenestebinding,
  Aarsavtale,
  TelefonBinding,
}

export class PcmBindingTypeModel {
  description: string;
  value: PcmBindingType;
}

export class PcmCommitmentTypeModel {
  description: string;
  value: PcmCommitmentType;
}
